import { GameState } from './GameState';
import { PetCareEngine } from './PetCareEngine';
import { PETS_FOR_EGG } from '../data/pets';
import { EventBus } from './EventBus';
import type { Rarity } from '../types';

// 알 부화 기본 6시간 — 어렵게
export const EGG_HATCH_DURATION_MS = 6 * 60 * 60 * 1000;
// 부화 단축 비용: 남은 분당 5코인 (예: 6시간 = 360분 = 1800코인)
export const EGG_SPEEDUP_COIN_PER_MIN = 5;

const RARITY_WEIGHT: Record<Rarity, number> = {
  common: 50,
  rare: 30,
  epic: 12,
  legend: 3,
  season: 5,
};

function pickEggPet(ownedIds: Set<string>): string {
  const pool = PETS_FOR_EGG.filter(p => !ownedIds.has(p.id));
  const list = pool.length > 0 ? pool : PETS_FOR_EGG;
  if (list.length === 0) return 'pet_dog_brown'; // 클린 슬레이트 폴백
  const total = list.reduce((s, p) => s + (RARITY_WEIGHT[p.rarity] ?? 10), 0);
  let r = Math.random() * total;
  for (const p of list) {
    r -= RARITY_WEIGHT[p.rarity] ?? 10;
    if (r <= 0) return p.id;
  }
  return list[list.length - 1].id;
}

export const EggHatcher = {
  startHatching(durationMs: number = EGG_HATCH_DURATION_MS): void {
    const ownedIds = new Set(GameState.data.ownedPets.map(p => p.petId));
    const petId = pickEggPet(ownedIds);
    GameState.data.hatchingEggs.push({ petId, readyAt: Date.now() + durationMs });
    GameState.persist();
    EventBus.emit('toast', { message: '🥚 알 부화 시작!', kind: 'gold' });
  },

  /** 남은 시간 분 단위 (올림) */
  remainingMinutes(eggIndex: number): number {
    const e = GameState.data.hatchingEggs[eggIndex];
    if (!e) return 0;
    return Math.max(0, Math.ceil((e.readyAt - Date.now()) / 60000));
  },

  /** 단축 비용 (코인) */
  speedUpCost(eggIndex: number): number {
    return this.remainingMinutes(eggIndex) * EGG_SPEEDUP_COIN_PER_MIN;
  },

  /** 부화 즉시 완료 — 남은 시간만큼 코인 차감 (호출자가 EconomyEngine.spend 처리) */
  finishNow(eggIndex: number): boolean {
    const e = GameState.data.hatchingEggs[eggIndex];
    if (!e) return false;
    e.readyAt = Date.now();
    GameState.persist();
    return true;
  },

  checkReadyEggs(): { petId: string }[] {
    const now = Date.now();
    const ready = GameState.data.hatchingEggs.filter(e => e.readyAt <= now);
    if (ready.length === 0) return [];
    GameState.data.hatchingEggs = GameState.data.hatchingEggs.filter(e => e.readyAt > now);
    for (const e of ready) {
      PetCareEngine.addPet(e.petId);
    }
    return ready;
  },
};
